import { useEffect, useState } from "react";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import styles from "./ProgressiveImg.module.css";

type ProgressiveImageProps = {
  placeholderSrc: string;
  src: string;
  alt?: string;
};

const ProgressiveImg = ({
  placeholderSrc,
  src,
  alt,
  className
}: PropsWithClassName<ProgressiveImageProps>) => {
  const [imgSrc, setImgSrc] = useState(placeholderSrc || src);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setImgSrc(src);
    };
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt || ""}
      className={`${className} ${
        placeholderSrc && imgSrc === placeholderSrc
          ? styles.loading
          : styles.loaded
      }`}
    />
  );
};
export default ProgressiveImg;
